"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Build a Promise that will resolve after the specified number of milliseconds.
 * @param ms milliseconds to wait
 * @param value value for eventual resolution
 */
function delay(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
exports.default = delay;
//# sourceMappingURL=helpers.js.map